import { render, staticRenderFns } from "./InfoTabs.vue?vue&type=template&id=5f48349b&scoped=true&"
import script from "./InfoTabs.vue?vue&type=script&lang=js&"
export * from "./InfoTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f48349b",
  null
  
)

export default component.exports